import { uploadUrl } from '../lib/api';
import { initials } from '../lib/format';

const SIZES = { sm: 'size-6 text-[10px]', md: 'size-8 text-xs', lg: 'size-12 text-sm' };

export function Avatar({
  name,
  src,
  size = 'md',
}: {
  name: string;
  src?: string;
  size?: keyof typeof SIZES;
}) {
  const href = uploadUrl(src);
  if (href) {
    return (
      <img
        src={href}
        alt=""
        className={`${SIZES[size]} shrink-0 rounded-full object-cover`}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={`${SIZES[size]} inline-flex shrink-0 items-center justify-center rounded-full bg-surface-2 font-medium text-ink-2`}
    >
      {initials(name)}
    </span>
  );
}

/** Avatar + name + secondary line, the recurring "who" cell in every table. */
export function UserCell({
  name,
  secondary,
  src,
  trailing,
  secondaryTitle,
}: {
  name: string;
  secondary?: string;
  src?: string;
  trailing?: React.ReactNode;
  /** The untruncated secondary text, shown on hover when `secondary` is shortened. */
  secondaryTitle?: string;
}) {
  return (
    <div className="flex items-center gap-2.5">
      <Avatar name={name} src={src} />
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <span className="truncate font-medium text-ink">{name}</span>
          {trailing}
        </div>
        {secondary && <div className="truncate text-xs text-ink-3" title={secondaryTitle}>{secondary}</div>}
      </div>
    </div>
  );
}
